import { faCrown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import './TopLeaders.css';
import type { ChallengeTypeApi } from '../../types/api/challenges';
import type { ChallengeLeaderEntryRedux } from '../../types/models/challenges';

import { useImageExists } from '../../shared/hooks/useImageExists';
import { getChallengeTypeUnit, getFormattedValue, getInitial } from '../../shared/util/challenges';

interface SingleLeaderProps {
  leader: ChallengeLeaderEntryRedux | number;
  index: number;
  leadersNumber: number;
  challengeType: ChallengeTypeApi | string;
}

function SingleLeader({ leader, index, leadersNumber, challengeType }: SingleLeaderProps) {
  const { t } = useTranslation();
  const leaderEntry = typeof leader === 'object' ? leader : null;
  const imageExists = useImageExists(leaderEntry?.image);

  return (
    <div
      key={index}
      className={`leader leader-${index}`}
      role="group"
      aria-labelledby={` leader-progress-${index} leader-progress-unit-${index}`}
    >
      {index !== 0 && (
        <div className="leader-number" aria-hidden="true">
          {index + 1}
        </div>
      )}
      {index === 0 && <FontAwesomeIcon style={{ color: '#62BF92' }} icon={faCrown} />}
      <div className={`leader-avatar-outer leader-avatar-outer-${index}`}>
        <div
          className={`leader-avatar leader-avatar-${index} fs-exclude`}
          style={
            leaderEntry?.image && imageExists
              ? { backgroundImage: `url(${leaderEntry.image})` }
              : {}
          }
        >
          <div
            aria-hidden="true"
            className="leader-initial"
            style={
              leaderEntry?.image && imageExists
                ? {
                    display: 'none',
                  }
                : {}
            }
          >
            {getInitial(leaderEntry?.name || '')}
          </div>
        </div>
      </div>
      <div
        className={`leader-progress leader-progress-${index} ${
          leadersNumber === 0 ? 'inactive' : 'active'
        }`}
        id={`leader-progress-${index}`}
        aria-hidden="true"
      >
        <span className="visuallyHidden">
          {index + 1} {t('challenge.leaderboard.rank.label')}
        </span>
        {leaderEntry?.score ? getFormattedValue(leaderEntry.score, challengeType) : 0}
      </div>
      <div
        className={`leader-progress-unit ${
          leadersNumber === 0 ? 'inactive' : 'active'
        } ${index === 0 ? 'first' : 'other'}`}
        id={`leader-progress-unit-${index}`}
        aria-hidden="true"
      >
        {getChallengeTypeUnit(challengeType, leaderEntry?.score)}
      </div>
    </div>
  );
}

export default SingleLeader;
